import { usePageExperienceContext } from '@/features/experiences/contexts/PageExperienceContext';
import {
  ExperienceChildConfigKind,
  ExperienceStyles,
  ExperienceTypes,
} from '@/types/gql.generated';
import { Box } from '@/ui';
import { printVisibility } from '../../lib/printStyles';
import { ColorBackground } from './ColorBackground';
import { GradientBackground } from './GradientBackground';
import { PatternBackground } from './PatternBackground';
import { PrintBackground } from './PrintBackground';
import { SceneBackground } from './SceneBackground';

export type BackgroundProps = {
  themeId?: string | null;
};

export const Background = () => {
  const { experience } = usePageExperienceContext();

  if (experience.kind === ExperienceChildConfigKind.Printable) {
    return <PrintBackground />;
  }

  // The modern planner renders on a neutral canvas — the primary color is used
  // on page elements, not the page background. Legacy Page experiences keep
  // their configured background (color / gradient / scene / pattern) below.
  if (experience.type === ExperienceTypes.Planner) {
    return (
      <Box
        bg="var(--experience-page-canvas)"
        inset="0"
        pointerEvents="none"
        pos="fixed"
        sx={printVisibility.hide()}
        zIndex={-1}
      />
    );
  }

  if (experience.style === ExperienceStyles.Scene) {
    return <SceneBackground themeId={experience.styleId} />;
  }
  if (experience.style === ExperienceStyles.Gradient) {
    return <GradientBackground themeId={experience.styleId} />;
  }
  if (experience.style === ExperienceStyles.Pattern) {
    return <PatternBackground themeId={experience.styleId} />;
  }

  return <ColorBackground themeId={experience.styleId} />;
};
